import { Loading } from '@/components/loading/Loading';
import Navigation from '@/components/nav/Nav';
import { cn } from '@/lib/utils';
import { Outlet, useNavigation } from 'react-router';

function RootLayout() {
	const navigation = useNavigation();
	const isNavigating = Boolean(navigation.location);

	return (
		<div className="dark:bg-slate-900 overflow-y-auto h-full min-h-full flex flex-col relative pt-5">
			{isNavigating && <Loading />}
			<Navigation />
			<div className={cn('p-10 grow-1', { 'opacity-50': isNavigating })}>
				<Outlet />
			</div>
		</div>
	);
}

export default RootLayout;
